export enum InvoiceAction {
  View = 'VIEW',
  Edit = 'EDIT',
  Resend = 'RESEND',
  Cancel = 'CANCEL',
  DownloadXml = 'DOWNLOAD_XML',
  DownloadDanfe = 'DOWNLOAD_DANFE',
  SendEmail = 'SEND_EMAIL',
  RefreshStatus = 'REFRESH_STATUS',
  Support = 'SUPPORT'
}
